// extracted by mini-css-extract-plugin
module.exports = {"LastSwiperItem":"LastSwiperItem_LastSwiperItem__Ufv0n"};